module.exports = __webpack_public_path__ + "img/logo.1f225976.png";